import commonStrings from 'owa-strings/owa-mail-strings';
import safeOpenExternalLink from './safeOpenExternalLink';
import { getCurrentUrl } from './getCurrentUrl';
import { getModuleIndexUrl } from './getModuleIndexUrl';
import { getReadingPaneDeepLinkURL } from 'mini-mail-reading-pane-view/lib/utils/getReadingPaneDeepLinkURL';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';
import { HeaderIcon } from 'mini-header';
import { logUsage } from 'owa-analytics';
import { MiniIcons } from 'owa-mini-icons';
import { OPEN_IN_FULL_SCREEN_DP_NAME } from 'extension-header/lib/constants/telemetryConstants';

interface GetOpenInNewWindowIconProps {
    clickHandler?: (event) => void;
    isPrimary?: boolean;
}

export function getOpenInNewWindowIcon({
    clickHandler,
    isPrimary = true,
}: GetOpenInNewWindowIconProps = {}): HeaderIcon {
    return {
        icon: MiniIcons.OpenInNewWindow,
        ariaHasPopup: true,
        ariaLabel: commonStrings.OpenInNewTabText,
        isPrimary,
        onClick: event => {
            event.stopPropagation();
            setTimeout(window.close, 0);
            logUsage(
                OPEN_IN_FULL_SCREEN_DP_NAME,
                {
                    currentUrl: getCurrentUrl(),
                },
                { isCore: true }
            );

            if (clickHandler) {
                return clickHandler(event);
            }
            safeOpenExternalLink(getModuleIndexUrl());
        },
    };
}

export enum ModalDialogType {
    MailModule,
    Email,
}

export const tenantPreventionOutlookExpansion = (modalType: ModalDialogType) => {
    switch (modalType) {
        case ModalDialogType.Email: {
            const rowId = getMailStore().mailModule.selectedId;
            safeOpenExternalLink(getReadingPaneDeepLinkURL(rowId));
            break;
        }
        case ModalDialogType.MailModule:
        default:
            safeOpenExternalLink(getModuleIndexUrl());
    }
};
